import { Card, ImageList, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { orderBy } from "lodash";
import { useState } from "react";
import { EntitiyType } from "src/types/apps";

import EntityItem from "./EntityItem";
import ModifyEntityDialog from "./ModifyEntityDialog/ModifyEntityDialog";
import useGetEntities from "./useGetEntities";

// ----------------------------------------------------------------------

export default function EntitiesStatus() {
	const [selectedEntity, setSelectedEntity] = useState<EntitiyType | null>(null);

	const { entities } = useGetEntities();
	const queryClient = useQueryClient();

	const onClick = (value: EntitiyType) => {
		setSelectedEntity(value);
	};

	const onClose = (isSuccess?: boolean) => {
		setSelectedEntity(null);
		isSuccess && queryClient.refetchQueries({ queryKey: ["entities"] });
	};

	return (
		<Card sx={{ p: 3 }}>
			<Typography sx={{ mb: 2 }} variant='h6'>
				{"Modifica el mantenimiento de las entidades"}
			</Typography>
			<ImageList cols={5} sx={{ mt: 2, pb: 2 }}>
				{orderBy(entities, "name").map((i, index) => (
					<EntityItem item={i} key={index} onClick={onClick} />
				))}
			</ImageList>
			<ModifyEntityDialog onClose={onClose} entity={selectedEntity} />
		</Card>
	);
}
